class window.Timer
  constructor: ->
    @initTimer()

  initTimer: ->
    timer = ->
      elmnt = ''
      nowDate = new Date
      achiveDate = new Date(2020, 4, 9, 0, 0, 0)
      #Задаем дату, к которой будет осуществляться обратный отсчет
      result = achiveDate - nowDate + 1000
      if result < 0
        elmnt = document.getElementById('timer')
        elmnt.innerHTML = ' - : - - : - - : - - '
        return undefined
      seconds = Math.floor(result / 1000 % 60)
      minutes = Math.floor(result / 1000 / 60 % 60)
      hours = Math.floor(result / 1000 / 60 / 60 % 24)
      days = Math.floor(result / 1000 / 60 / 60 / 24)
      if seconds < 10
        seconds = '0' + seconds
      if minutes < 10
        minutes = '0' + minutes
      if hours < 10
        hours = '0' + hours
      elmnt_day = document.getElementById('day')
      elmnt_hour = document.getElementById('hour')
      elmnt_min = document.getElementById('min')
      elmnt_sec = document.getElementById('sec')
      elmnt_day.innerHTML = days
      elmnt_hour.innerHTML = hours
      elmnt_min.innerHTML = minutes
      elmnt_sec.innerHTML = seconds
      setTimeout timer, 1000
      return

    window.onload = ->
      timer()
      return





// WEBPACK FOOTER //
// ./assets/javascripts/app/timer.coffee